<template>
<div class="container">
  <div class="message">
    <h2 class="size-large">Error 404:<br />Page not found</h2>
    <p>The page you requested could not be found.</p>
  </div>
</div>
</template>

<script>
import Vue from 'vue'

export default Vue.component('RouteNotFound', {})
</script>

<style scoped lang="scss">
@import '~@/_variables.scss';
.container {
  min-height: 100vh;
  background: $color-gray;
}

.message {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  color: $color-white;
  text-align: center;
}

h2 {
  line-height: 1;
  text-transform: uppercase;
  margin-bottom: 0.6em;
}

p {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/routes/route-not-found.vue